<template>
  <div
    :class="{ fixed_menu: !isHomeRouter }"
    :style="{ height: isHomeRouter ? '0px' : isMobile ? '1.59rem' : '72px' }"
  >
    <div v-if="isMobile" class="m_menu_component">
      <div class="menu_btn" @click="menuOpen">
        <img v-show="!menuActive" src="@/assets/menu_btn.png" alt="" />
        <img v-show="menuActive" src="@/assets/close.png" alt="" />
        <p>Home Page</p>
      </div>
      <img class="m_logo" src="@/assets/logo_h.png" alt="" />
      <div class="menu_wrap" :class="{ menuActive: menuActive }">
        <ul>
          <li>
            <div class="menu_item" @click="goTo('/')"><p>Home Page</p></div>
          </li>
          <li>
            <div
              class="menu_item"
              :class="{ up: itemActive === 1 }"
              @click="toggleDown(1)"
            >
              <p>Product Centre</p>
              <img src="@/assets/down.png" alt="" />
            </div>
            <div class="down_list" :class="{ show: itemActive === 1 }">
              <div class="down_item" @click="goTo('/UCL360')">
                <span>Space Scanning</span>
              </div>
              <div class="down_item" @click="goTo('/ScanToBIM')">
                <span>SCAN TO BIM</span>
              </div>
            </div>
          </li>
          <li>
            <div class="menu_item" @click="goTo('/Solution')">Solution</div>
          </li>
          <li>
            <div class="menu_item" @click="goTo('/Case')">Customer Cases</div>
          </li>
          <li>
            <div class="menu_item" @click="toggleDown(2)">
              <p>About UNRE</p>
              <img
                :class="{ up: itemActive === 2 }"
                src="@/assets/down.png"
                alt=""
              />
            </div>
            <div class="down_list" :class="{ show: itemActive === 2 }">
              <div class="down_item" @click="goTo('/About')">About UNRE</div>
              <div class="down_item" @click="goTo('/News')">News</div>
              <div class="down_item" @click="goTo('/Contact')">Contact Us</div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="menu_component" v-else>
      <!-- <h1>{{ msg }}</h1> -->
      <div class="menu_center">
        <div class="logo" @click="goTo('/')"></div>
        <div class="right_wrap">
          <ul class="menu_ul">
            <li @click="goTo('/')"><p>Home Page</p></li>
            <li>
              <p>Product Centre</p>
              <div class="sub_navs">
                <div class="sub_item" @click="goTo('/UCL360')">
                  Space Scanning
                </div>
                <div class="sub_item" @click="goTo('/ScanToBIM')">
                  SCAN TO BIM
                </div>
              </div>
            </li>
            <li @click="goTo('/Solution')"><p>Solution</p></li>
            <li @click="goTo('/Case')"><p>Customer Cases</p></li>
            <li>
              <p>About UNRE</p>
              <div class="sub_navs">
                <div class="sub_item" @click="goTo('/About')">About UNRE</div>
                <div class="sub_item" @click="goTo('/News')">News</div>
                <div class="sub_item" @click="goTo('/Contact')">Contact Us</div>
              </div>
            </li>
            <li style="margin-right:0">0755-26401645</li>
            <li class="lang">
              <img class="zh" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATLSURBVHgB7ZlNbttGFIDfzFCBW7SFjqAb1C4Ku0EXldfduIidoigQiSdIfQLLJ5BzAlrpokgcV/YJqi6K1HYA6wjKtpuqXRSG1Znpe5REkBTJmaFEOwH6AUrM4ZB8b/j+5pHBEgTBdR0+lE3h6a9Aq4YGto7D9dmPGIOGEWP4P2ND+S/7Ff4RA9/fGMOKYFCC4OSqKZg+0ABzgR0fqs+kFD3/28/PYEmcFAhevNnhnuriqjZgFTAYKQmH/uPNYyiJlQLBT68boiYCXPEmVAAKMZAT6fvfPRyBI9w0ode/fMpr4jpH+JXYMt2bnhGc/P4DOFKoQO/06gAkHEHKzvGBA6XltsIpsDrqnPHuj/RMB3IVeH56hbauO4lBslkUvL27ue3vPRwIgE9hxSh8posSmQrQymutE68zXPW/axskOFSMixILTkw2PzObOM9au5sL9knOTbYLJUKpDUqrfX/vi6OiOTwtEArfSczQ+jBLeIKiBq7WM6gI9ImDUKaiOYmDmuhDbDU1JpzW3lan6AY+nUffgGqoU/gumhApELy8bMM0s05BofRE7YMFFMehIijEBievm3nnIwW4gITThBnSIrFMHR7aUCGciW7eudCJg1cXOxxYPzY4eIKhEgyEeSIdamPg6h2jGZ5joTfOEGgdHKDwnRUBPfpHMN7CsBkNSi0PTTcMTa5AeHL+do7/YI4Z4fOcFBBMkIUM0uM86F/X8WY70QjavlWsZ3KUe44iV47wFFUSz7OEKt+wfE/BQd42UzPPwYJQyazoo3WvMHI9YM7Cz8C9R0pWCJ2YJQbR1qxrdHUrt0lgXJ1hODAVvl18EXMynThcJGUlPKpndGzApVSYRak2uMCAFqgFJcDM3EiPcdwGxu1qCBXj726dYRVbKntzzheKRzQh3ZgfsBXV9yZ8LE2wBDFGugX0Ys1FYTQalFr9BXeEP3X0DixJohZinP8J7xmkQGQ2fFWb9TuETIgUCM1IM7MCvZ/ftECphW3mnUM5iPEOZ9hwigbxDWRluwRadeC+hSfIWnAhudT6beLERzfrxgvfHeocUpmXA2/Ce4QH3toQ5CTyA6x1KUt2bG+A203r7l7v1WWU9NHfjtuPNv35cfDyt3XOa9fpa7wPvMb3X3/2Nuseobj+NxtjFs/A5AcFO6Cq8B9/OSyT3ML9ANX/uMlozgfzam8TVJrDZFK22kRpHhyBmrRc/CxMZLMCLnoL4T70xYW7IDc3dc4hyPuZLidrUEr64ECUibGMTmzguce6xpBaAbSYLsUej1+Y6C7gaxQfT/rgwtramOx44WchUKL/I2rWrRovfkAt7ninjUzp+elF98mjLav2CpkAZESwULiaeFp4scfbGDwGtJB0H/zbR7/8BQwkirlpp00lIoHWzLnlXRbORTA3W1tT8tID1IsMTi6w1c2c2tzErFdqXLVcyGw/uaXnTt84mtLtH8WXZHanqVYvteGY0sj5WUFvfJ6HyJRMHwRzvw8sqcRSxE3JhFd0kpTAzz7220yKQpMbv0gwsCFtSgV4pgmm/nxi7jQKHeedxzrGTgGITOnc1CUxfuS7TzjkN3XnOH/oTleD9807/QZsKKPAnfSOrMByw1kBrBb3K/yk5MIYM/W9hPn/ifMfpfkakopPMX0AAAAASUVORK5CYII=" alt="" srcset="">
              <div class="sub_navs">
                <div class="sub_item"  >
                  <a href="https://www.unre.com/#/">
                    <img  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVGSURBVHgB7VldTiNHEK7uHqNVtJs4N/ANAlIC4SnmBAEJNsrL2nOCZE+AOQFwgsHkIdoAMXsCnCcCrAQ3WOcEcX4URYbuTlXPeJgZz0+3sdldKZ80Hk1PT3dVu7p+vmbwAATBdR0+kk3h6a9Aq4YGtojN9egiDEHDgDG8M3Yj79gv8I/o+/7SEGYEBlMgOLpqCqa3NcBYYMdJ9amUout/8/kpPBBOCgSv3qxzT+3iqjZgFmAwUBJ2/OfLBzAlrBQIfjxviJoIcMWbMAegEH15K33/29UBOIJXdej2Lr/jNXFdIPxMbJnGpjmCo1+/B0eUKtA9udoGCXuQsXOcsK+0XFPYBWaHOmd89wea0wGFChyeXKGt606qkWwWBW9vLq/5W6t9AfAZzBgK53RRIlcBWnmtdervNKv+Z22JBIc5w0WJiU1MNh+ZTRL7rc3lCfukzU22C1O4UhsorV76W1/ulfXhWYFQ+E6qh9Y7ecITyGvgau3DnIB7YtvIVNYn9VATPUispsaA09pa6ZQN4NN73BswH9TJfZd1iBUIfrpsQxhZQ6BQ+la9BAuQH4c5gVxscHTeLHofK8AFpDaNiZAWgSXc8NCGOYIzsVv0zmzi4PhinQPrJRr7L9BVQgVMnMi62gRw9Q7QDF9jojfMEWgRHEDuO88DevQjGG+h24wbpZY7VQMakysRnjZ/u2D/YIwZ4HxOCggmyEL62XYe9K7rONh63IK2b+XrmRwUviPPVSA8eZXUfJagzNek7xlwkKNmpudrsIBRMs/7aN0t9VwLzFn4CFh7ZGQFs4lZqhFtzTpHVyO5RgLj6tyYhlD4dvlHzMl0kuAiLSvBo3xGJxpcUoXIS7XBBQxogVowBTAyN7JtHMvApF3dwJzhb66cYhY7VfTmnE8kj2hCujF+YDPK76vgY2qCKUilp5uAnsy5yI3GjVKrP+CR4IcbvQMPRCoXYpz/Dh8YSIHYbPisivVHBJkQKWDMSLNqBbo/v2mBUhNl5qODYhDjHc6QcIob8R/Ii3YpaNWBdy08gawFF5JLrX9LvXj672Llh+8P6hwykZcDb8IHBA7eEzKhe//P2VRRksYg327olr9qn2IZyuhOz5RiFHyzb/pHV0FhlOqTfWnqgcPjy7MkcVWUexO6x5caJkcZUF5UVgAZAmBBnCVNUCnwk7RiRBK8TX6X7ZOd38SBbP4f5d7WyApP5C/VC3QftxkCYCRLi6SIJHCK0EaBaLVjb2Tq0FcXVmkvVV1J4YkQ40yfcQ4B3Q9PLoOkgAxYebbrLey5kARxJEazSRXw3GO7lS6VFNAytu+oOEoTYlgvB73zxvjSQvfLxvM3loZKSR8sEStA/0JqE6Gtime3vcoR/n5yH0fu7nJdMJfi7fjKIc1ijDkgksU2Y03lQkRxQ8IjkSkdnlzslg0wy9OWFAckah2wyI5TCoSbSKU2kdbMmfKeFiEHFFLskSlV8lIT5C5xkS6ewGafuMDQidGY/vPVA6jJfmn/vEbK1a2VSKYenpdb0SUDkYVt18Wz0b3n2ign1wrPB2yVQJJq/X6ypSEd4GW67NOmHF+CwSdVY2KZu15GJ6bmL3sZKlHJj7aSDPKLzZUNBXqDXCGteJLZDjkhOxKAcxHYmKdX1aGKnwfKCDFFQOHiaEyFe7ZTIpWwA7nxj0eUEZQuoPM5cW4uFGKIB9qnUrGuv/VFnxrMCj69WxQcvsYA14ZsHYEpjAKvP36kyJ0dlHIhPCQfFPWZpQLvBJXHrO87plHgUbgjK2DS56yAiY7zO1JywRBjijs59j9mjP8AXhiepZPJ2LAAAAAASUVORK5CYII=" alt="" srcset="">
                  <span>简体中文</span>
                  </a>
                </div>
                <div class="sub_item"  >
                  <a href="https://en.unre.com/#/">
                    <img  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATLSURBVHgB7ZlNbttGFIDfzFCBW7SFjqAb1C4Ku0EXldfduIidoigQiSdIfQLLJ5BzAlrpokgcV/YJqi6K1HYA6wjKtpuqXRSG1Znpe5REkBTJmaFEOwH6AUrM4ZB8b/j+5pHBEgTBdR0+lE3h6a9Aq4YGto7D9dmPGIOGEWP4P2ND+S/7Ff4RA9/fGMOKYFCC4OSqKZg+0ABzgR0fqs+kFD3/28/PYEmcFAhevNnhnuriqjZgFTAYKQmH/uPNYyiJlQLBT68boiYCXPEmVAAKMZAT6fvfPRyBI9w0ode/fMpr4jpH+JXYMt2bnhGc/P4DOFKoQO/06gAkHEHKzvGBA6XltsIpsDrqnPHuj/RMB3IVeH56hbauO4lBslkUvL27ue3vPRwIgE9hxSh8posSmQrQymutE68zXPW/axskOFSMixILTkw2PzObOM9au5sL9knOTbYLJUKpDUqrfX/vi6OiOTwtEArfSczQ+jBLeIKiBq7WM6gI9ImDUKaiOYmDmuhDbDU1JpzW3lan6AY+nUffgGqoU/gumhApELy8bMM0s05BofRE7YMFFMehIijEBievm3nnIwW4gITThBnSIrFMHR7aUCGciW7eudCJg1cXOxxYPzY4eIKhEgyEeSIdamPg6h2jGZ5joTfOEGgdHKDwnRUBPfpHMN7CsBkNSi0PTTcMTa5AeHL+do7/YI4Z4fOcFBBMkIUM0uM86F/X8WY70QjavlWsZ3KUe44iV47wFFUSz7OEKt+wfE/BQd42UzPPwYJQyazoo3WvMHI9YM7Cz8C9R0pWCJ2YJQbR1qxrdHUrt0lgXJ1hODAVvl18EXMynThcJGUlPKpndGzApVSYRak2uMCAFqgFJcDM3EiPcdwGxu1qCBXj726dYRVbKntzzheKRzQh3ZgfsBXV9yZ8LE2wBDFGugX0Ys1FYTQalFr9BXeEP3X0DixJohZinP8J7xmkQGQ2fFWb9TuETIgUCM1IM7MCvZ/ftECphW3mnUM5iPEOZ9hwigbxDWRluwRadeC+hSfIWnAhudT6beLERzfrxgvfHeocUpmXA2/Ce4QH3toQ5CTyA6x1KUt2bG+A203r7l7v1WWU9NHfjtuPNv35cfDyt3XOa9fpa7wPvMb3X3/2Nuseobj+NxtjFs/A5AcFO6Cq8B9/OSyT3ML9ANX/uMlozgfzam8TVJrDZFK22kRpHhyBmrRc/CxMZLMCLnoL4T70xYW7IDc3dc4hyPuZLidrUEr64ECUibGMTmzguce6xpBaAbSYLsUej1+Y6C7gaxQfT/rgwtramOx44WchUKL/I2rWrRovfkAt7ninjUzp+elF98mjLav2CpkAZESwULiaeFp4scfbGDwGtJB0H/zbR7/8BQwkirlpp00lIoHWzLnlXRbORTA3W1tT8tID1IsMTi6w1c2c2tzErFdqXLVcyGw/uaXnTt84mtLtH8WXZHanqVYvteGY0sj5WUFvfJ6HyJRMHwRzvw8sqcRSxE3JhFd0kpTAzz7220yKQpMbv0gwsCFtSgV4pgmm/nxi7jQKHeedxzrGTgGITOnc1CUxfuS7TzjkN3XnOH/oTleD9807/QZsKKPAnfSOrMByw1kBrBb3K/yk5MIYM/W9hPn/ifMfpfkakopPMX0AAAAASUVORK5CYII=" alt="" srcset="">
                  <span>  English</span>
                  </a>
                </div>
              </div>
            </li>
          </ul>
          <a
            class="login_btn"
            href="https://console.zhihuiliang.com/"
            target="_blank"
            >login</a
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isMobile } from "@/utils";
export default {
  props: {
    msg: String,
  },
  data() {
    return {
      isMobile: false,
      menuActive: false,
      itemActive: 0,
      isHomeRouter: true,
    };
  },
  watch: {
    $route: function () {
      if (this.$route.name === "Home") {
        this.isHomeRouter = true;
      } else {
        this.isHomeRouter = false;
      }
    },
  },
  components: {},
  created() {
    this.isMobile = isMobile();
  },
  mounted() {},
  methods: {
    menuOpen() {
      this.menuActive = !this.menuActive;
    },
    toggleDown(index) {
      if (this.itemActive === 0) {
        this.itemActive = index;
      } else {
        this.itemActive = 0;
        this.itemActive = index;
      }
    },
    goTo(path) {
      this.$router.push({ path: path });
      this.menuActive = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.fixed_menu {
  height: 72px;
  .menu_component {
    position: fixed;
    background: #fff;
    .menu_center {
      .logo {
        background: url(../assets/logo_h.png);
        background-size: 100% 100%;
      }
      .right_wrap {
        color: #808080;
      }
    }
  }
}
.menu_component {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
  transition: all 0.5s;

  &:hover {
    background: #fff;

    .menu_center {
      .logo {
        background: url(../assets/logo_h.png);
        background-size: 100% 100%;
      }
      .right_wrap {
        color: #808080;
      }
    }
  }
  .menu_center {
    width: 7.6rem;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .logo {
      background: url(../assets/logo.png);
      background-size: 100% 100%;
      width: 1.32rem;
      height: 0.11rem;
    }
  }
  .right_wrap {
    display: flex;
    align-items: center;
    color: #fff;

    font-size: 16px;
    .menu_ul {
      display: flex;
      justify-content: center;
      li {
        margin-right: 0.05rem;
        list-style-type: none;
        padding: 0px 0.1rem;
        cursor: pointer;
        position: relative;
        line-height: 72px;
        &.lang{
  margin: 0;
  .zh{
    width: 24px;
    margin-top: 22px;
  }
  .sub_item{
    display: flex;
    align-items: center;
    width: auto;
    a{
      text-decoration: none;
      color: rgb(128, 128, 128);
      display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 26px;
    }
  }
  img{
    width: 24px;
    margin-right: 5px;
  }
}
        &:hover {
          p {
            color: #02aeec;
          }
          .sub_navs {
            display: block;
          }
        }
        .sub_navs {
          display: none;
          background-color: #fff;
          position: absolute;
          top: 72px;
          left: 50%;
          transform: translateX(-50%);
          width: 160px;
          .sub_item {
            line-height: 60px;
            &:hover {
              background: #02aeec;
              color: #fff;
            }
          }
        }
      }
    }
    .login_btn {
      width: 110px;
      color: #fff;
      height: 40px;
      background: #07ace7;
      border-radius: 3px 3px 3px 3px;
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      cursor: pointer;
      &:hover {
        opacity: 0.7;
      }
    }
  }
}
@media screen and (max-width: 1680px) {
  .menu_component {
    .menu_center {
      width: 85%;
    }
    .right_wrap {
      font-size: 16px;
    }
  }
}
@media screen and (max-width: 1420px) {
  .menu_component {
    .menu_center {
      width: 90%;
    }
    .right_wrap {
      font-size: 14px;
    }
  }
}
@media screen and (max-width: 1300px) {
  .menu_component {
    .menu_center {
      width: 94%;
    }
    .right_wrap {
      font-size: 12px;
    }
  }
}
@media screen and (max-width: 990px) {
  .menu_component {
    .menu_center {
      width: 98%;
    }
    .right_wrap {
      font-size: 12px;
    }
  }
}
.m_menu_component {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 10rem;
  height: 1.59rem;
  background: #ffffff;
  padding: 0 0.43rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #333333;
  font-size: 0.45rem;
  .m_logo {
    width: 2.28rem;
  }
  .menu_wrap {
    width: 5rem;
    position: absolute;
    z-index: 10;
    left: 0;
    top: 1.59rem;
    z-index: 100;
    background-color: #fff;
    transition: all 0.15s;
    transform: translate3d(-100%, 0, 0);
    padding: 0.3rem 0;

    &.menuActive {
      transform: translate3d(0, 0, 0);
    }
    ul {
      li {
        text-align: left;
        .menu_item {
          padding: 0.34rem 0.43rem;
          display: flex;
          justify-content: space-between;
          &:active {
            background-color: #ecf5ff;
          }
          img {
            width: 0.6rem;
            width: 0.6rem;
            transition: all 0.3s;
          }
          &.up {
            background-color: #ecf5ff;
            color: #02aeec;
            img {
              transform: rotate(180deg);
            }
          }
        }
      }
    }
    .down_list {
      display: none;
      .down_item {
        padding: 0.26rem 0.64rem;
        &:active {
          background-color: #ecf5ff;
        }
        color: #666666;
        font-size: 0.37rem;
      }
      &.show {
        display: block;
      }
    }
  }
  .menu_btn {
    display: flex;
    align-items: center;
    &:active {
      opacity: 0.7;
    }
    img {
      width: 0.64rem;
      margin-right: 0.32rem;
    }
    p {
    }
  }
}
</style>
